import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/integrations")({
  component: IntegrationsLayout,
});

function IntegrationsLayout() {
  return <Outlet />;
}
